import { GetterTree } from 'vuex'

import { RootState, QlogState } from '@/types/store'

export const getters: GetterTree<QlogState, RootState> = {
  logs(state): QlogState['logs'] {
    return state.logs
  },
  isLogsLoading(state): QlogState['isLogsLoading'] {
    return state.isLogsLoading
  },
}
